import React, { Component } from 'react';
import { PropTypes } from 'prop-types';

import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { STATIC_ROOT } from '../../constants';
import ButtonComponent from '../button/ButtonComponent';

import Tooltip from '../tooltip/Tooltip';
import SvgComponent from '../SvgComponent';

import './InformativeModal.scss';

class InformativeModal extends Component {
    handleConfirm = () => this.props.onConfirm();

    render() {
        const { i18n } = this.props;

        const i18nInstructions = i18n.INSTRUCTIONS;

        const instructions = [
            <span>
                {i18nInstructions.COOKIES}
                <Tooltip text={i18nInstructions.COOKIES_TOOLTIP}>
                    <SvgComponent
                        src={`${STATIC_ROOT}/info.svg`}
                        height="14"
                        className="information-badge"
                    />
                </Tooltip>
            </span>,
            <span>{i18nInstructions.CONDITIONS}</span>,
            <span>{i18nInstructions.TAB}</span>,
            <span>{i18nInstructions.AD_BLOCKER}</span>,
            <span>{i18nInstructions.MOBILE_APP}</span>
        ];

        return (
            <div className="informative-modal">
                <span className="title">{i18n.TITLE}</span>
                <span className="instruction-list-title">{i18n.INSTRUCTIONS_TITLE}</span>
                <div className="instruction-list">
                    {instructions.map((instruction, i) => (
                        <div className="list-item" key={i}>
                            <div className="list-bullet">
                                <SvgComponent src={`${STATIC_ROOT}/check.svg`} height="14" />
                            </div>
                            {instruction}
                        </div>
                    ))}
                </div>
                <span className="italic">{i18n.CONFIRMATION_MAIL}</span>
                <ButtonComponent
                    onClick={this.handleConfirm}
                    text={i18n.CONFIRMATION_BUTTON}
                    color="second"
                />
            </div>
        );
    }
}

InformativeModal.propTypes = {
    onConfirm: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
    i18n: state.i18n.page.INFORMATIVE_MODAL
});

export default withRouter(connect(mapStateToProps)(InformativeModal));



// WEBPACK FOOTER //
// ./src/components/informativemodal/InformativeModal.js